import { useQuery } from '@tanstack/react-query';

import type { Sprint } from '@tasks/contracts';

import { listSprints } from '../../api/sprints';
import { queryKeys } from '../../api/queryKeys';

/** Все спринты проекта (для селекторов доски, бэклога и отчётов). */
export function useSprints(projectKey: string): readonly Sprint[] {
  const query = useQuery({
    queryKey: queryKeys.projects.sprints(projectKey, 'all'),
    queryFn: ({ signal }) => listSprints(projectKey, undefined, signal),
    enabled: projectKey.length > 0,
  });
  return query.data ?? [];
}
